import { render, staticRenderFns } from "./eventDataModal.vue?vue&type=template&id=ad383660"
import script from "./eventDataModal.vue?vue&type=script&lang=js"
export * from "./eventDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports